module.exports = __webpack_public_path__ + "img/danger-alert.9fa86c6a.svg";